<template>
  <q-layout
    view="hHh Lpr lff"
    container
    style="height: 100vh"
    class="shadow-2 bg-grey-2"
  >
    <Header />
    <Sidebar />
    <q-page-container>
      <q-page>
        <page-marginer
          v-if="
            $route.path !== '/' &&
            $route.path !== '/vehicle-advanced' &&
            $route.path !== '/vehicle-advanced/list' &&
            $route.path !== '/vehicle-class-performance' &&
            $route.path !== '/vehicles' &&
            $route.path !== '/dimished-value-calculator' &&
            $route.path !== '/future-value' &&
            $route.path !== '/summary-future' &&
            $route.path !== '/projected-rev-loss' &&
            $route.path !== '/manheim-search' &&
            $route.path !== '/historical-trend' &&
            $route.path !== '/invoices' &&
            $route.path !== '/for-sale' &&
            $route.path !== '/blackbook' &&
            $route.path !== '/blackbook/list' &&
            $route.name !== 'blackbook_show' &&
            $route.path !== '/help'
          "
        >
          <component
            @locale-search="$emit('locale-search')"
            :is="stickyHeaderAutoInjecter"
          ></component>
          <slot></slot>
        </page-marginer>
        <div v-else style="padding: 25px">
          <component
            @vehicle-search="$emit('vehicle-search')"
            @table-search="$emit('table-search')"
            @clear-filter="$emit('clear-filter')"
            :is="stickyHeaderAutoInjecterForBig"
          ></component>
          <slot></slot>
        </div>
      </q-page>
    </q-page-container>
    <q-footer elevated class="white-1">
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 65px;
          align-items: center;
          text-align: center;
          font-size: 11px;
        "
      >
        <div v-if="$q.screen.gt.sm">FP does not guarantee the accuracy, completeness, or reliability of this data and assumes no responsibility for any errors or omissions. Users are solely responsible for verifying the accuracy of the information before making any purchasing or selling decisions. Users agree to hold FP harmless from any claims, damages, or losses related to third-party data.</div>
        <div>Patent Pending / Copyright © 2024 FLEET PERFECTION, LLC - All Rights Reserved.</div>
      </div>
    </q-footer>
  </q-layout>
</template>
<script>
import Header from "./Header";
import PageMarginer from "./PageMarginer";
import Sidebar from "./Sidebar";
import StickyHeader from "./StickyHeader";
import StickyHeaderVehicleClassPerformance from "./StickyHeaderVehicleClassPerformance.vue";
import StickyHeaderLocation from "./StickyHeaderLocation";
import StickyMillageHeader from "./StickyMillageHeader";
import StickyHeaderAnalysis from "./StickyHeaderAnalysis";
import CalculatorStickyHeader from "./CalculatorStickyHeader";
import StickyHeaderVehicleAdvanced from "./StickyHeaderVehicleAdvanced";
import StickyHistory from "./StickyHistory";
import StickyReports from "./StickyReports";
import StickyHeaderHistoricalTrend from "./StickyHeaderHistoricalTrend.vue";
export default {
  components: {
    StickyHistory,
    StickyReports,
    CalculatorStickyHeader,
    StickyHeaderVehicleAdvanced,
    StickyHeaderAnalysis,
    StickyMillageHeader,
    StickyHeaderLocation,
    StickyHeader,
    StickyHeaderVehicleClassPerformance,
    StickyHeaderHistoricalTrend,
    PageMarginer,
    Header,
    Sidebar,
  },
  data() {
    return {
      drawer: true,
    };
  },
  methods: {
    getDrawerValue(val) {
      this.drawer = val;
    },
  },
  computed: {
    stickyHeaderAutoInjecter() {
      const route = this.$route;
      if (route.path === "/") return "sticky-header-analysis";
      else if (route.path === "/locations") return "sticky-header-location";
      else if (route.path === "/mileage") return "sticky-millage-header";
      else if (route.path === "/operation-reports") return "sticky-reports";
      else if (route.path === "/calculator") return "calculator-sticky-header";
      else if (route.path === "/reports") return "sticky-history";
    },
    stickyHeaderAutoInjecterForBig() {
      const route = this.$route;
      if (route.path === "/vehicle-advanced" || route.path === "/for-sale" || route.path === "/blackbook")
        return "sticky-header-vehicle-advanced";
      else if (route.path === "/vehicles") return "sticky-header";
      else if (route.path === "/vehicle-class-performance") return "sticky-header-vehicle-class-performance";
      else if (route.path === "/historical-trend") return "sticky-header-historical-trend";
    },
    gridType() {
      return this.$store.state.vehicle.grid;
    },
  },
};
</script>
